import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import '../../App.css';
import AboutUltron from './AboutUltron';
import EnquiryForm from './EnquiryForm';
import FabricSource from './FabricSource';
import FabricWorks from './FabricWorks';
import FAQ from './FAQ';
import Footer from './Footer';
import SourceFabric from './SourceFabric';
import Stats from './Stats';
import Testimonials from './Testimonials';
import UltronFeatures from './UltronFeatures';

export default function WebsiteBody() {
  const { state } = useLocation();
  
  const faqRef = useRef(null);
  const contactRef = useRef(null);
  
  useEffect(() => {
    if (state?.faq) {
      faqRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if (state?.contactUs) {
      contactRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [state])



  useEffect(() => {
    AOS.init({ duration: 1000 })
  }, [])

  return (
    <>
      <FabricSource />
      <AboutUltron />
      <Stats />
      <UltronFeatures />
      <FabricWorks />
      {/* <Testimonials /> */}
      <FAQ faqRef={faqRef}/>
      <SourceFabric />
      <EnquiryForm contactRef={contactRef}/>
      <Footer faqRef={faqRef} contactRef={contactRef} />
    </>
  )
}